import { FunctionComponent } from 'react'
import styles from './TrusteeHome.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/modules/context/AuthContext'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import TranslateIcon from '@mui/icons-material/Translate'
import { LockReset } from '@mui/icons-material'
import ArticleIcon from '@mui/icons-material/Article'
import HelpIcon from '@mui/icons-material/Help'
import HomeCase from '../HomeCase/homeCase'

interface TrusteeHomeDesktopProps {
    backendVersion: string
    frontendVersion: string
    setDialogChangeLanguageOpen: (open: boolean) => void
    setDialogForgottenPasswordOpen: (open: boolean) => void
    setDialogSupportOpen: (open: boolean) => void
}

const TrusteeHomeDesktop: FunctionComponent<TrusteeHomeDesktopProps> = ({
    backendVersion,
    frontendVersion,
    setDialogChangeLanguageOpen,
    setDialogForgottenPasswordOpen,
    setDialogSupportOpen
}: TrusteeHomeDesktopProps) => {
    const { t } = useTranslation()

    const { logout } = useAuth()

    return (
        <div className={styles.PagePosition}>
            <div className={styles.HomePlacement}>
                <Title text={t('settings')} className={styles.Title} />
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('language')}
                        icon={<TranslateIcon className={styles.CaseIcon} />}
                        onClick={(): void => setDialogChangeLanguageOpen(true)}
                    />
                    <HomeCase
                        text={t('password')}
                        icon={<LockReset className={styles.CaseIcon} />}
                        onClick={(): void => setDialogForgottenPasswordOpen(true)}
                    />
                    <HomeCase text={t('logout')} icon={<LogoutIcon className={styles.CaseIcon} />} onClick={logout} />
                </div>
                <div className={styles.CaseContainer}>
                    <HomeCase
                        text={t('ourArticles')}
                        icon={<ArticleIcon className={styles.CaseIcon} />}
                        href={'https://www.cald.fr/nos-articles/'}
                    />
                    <HomeCase
                        text={t('help')}
                        icon={<HelpIcon className={styles.CaseIcon} />}
                        href={'https://www.cald.fr/aide-structure'}
                    />
                    <HomeCase
                        text={t('refresh')}
                        icon={<CachedIcon className={styles.CaseIcon} />}
                        onClick={removeServiceWorker}
                    />
                </div>
            </div>
            <div className={styles.Version}>
                <a onClick={() => setDialogSupportOpen(true)}>
                    V{backendVersion}/{frontendVersion}
                </a>
            </div>
        </div>
    )
}

export default TrusteeHomeDesktop
